if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
         this.cartNotification = document.querySelector('#cart-notification .cstm_edit_notification span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

     async onSubmitHandler(evt) {
       const cart = document.querySelector("cart-drawer");
       document.body.classList.add('cstm-freebie-add');
        evt.preventDefault();
           const res = await  fetch("/cart.js")
  const resData=  await res.json()
  console.log("resData" , resData)
      let check_free_product =  resData.items.some((item)=>{
         return item.id=="46693641519330"
       })
        let check_free_product1 =  resData.items.some((item)=>{
         return item.id=="46535596212450" 
       })
       let check_free_product2 = resData.items.some((item)=>{
         return item.id=="46718036771042"
       })
       console.log("check_free_product" , check_free_product)
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        this.querySelector('.loading__spinner').previousElementSibling.style.color="#000";
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        console.log("formDataformData" , formData)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
          console.log("config.body" , config.body )
        fetch(`${routes.cart_add_url}`, config)
          .then((response)=>{
             // console.log("responseresponse" , response)
            return response.json()
          })
          .then((response) => {
            console.log("responseresponsesdsds" , response)
               if(response.product_id=="8849132585186" || response.product_id=="8849131929826" || response.product_id=="8849132454114"|| response.product_id=="8849131667682") 
               { 
                 if(!check_free_product)
                 {
                        let payload = {
              items: [
                  {
                      id: '46693641519330',
                      quantity: 1
                  }
              ],
            sections: cart.getSectionsToRender().map((section) => section.id)
              };
                 fetch('/cart/add.js', {
                method: "POST", // Corrected typo in method
                headers: {
                    'Content-Type': 'application/json' // Corrected typo in headers
                },
                body: JSON.stringify(payload) // Corrected typo in JSON.stringify
            }).then((respose)=>{
                return respose.json()
              
            }).then((response)=>{
                cart.renderContents(response);     
            })
                 }
            
               }
               if(response.product_id=="8899096543458" || response.product_id=="8974465106146" || response.product_id=="8974431650018" || response.product_id=="8974392131810" || response.product_id=="8974357299426" || response.product_id=="8974183792866" || response.product_id=="8974166884578")
               { 
                 if(!check_free_product1)
                 {
                        let payload = {
            items: [
                // {
                //     id: '46535596212450',
                //     quantity: 1
                // }
              
            ],
            sections: cart.getSectionsToRender().map((section) => section.id)
        };
                 fetch('/cart/add.js', {
        method: "POST", // Corrected typo in method
        headers: {
            'Content-Type': 'application/json' // Corrected typo in headers
        },
        body: JSON.stringify(payload) // Corrected typo in JSON.stringify
    }).then((respose)=>{
         return respose.json()
       
    }).then((response)=>{
        cart.renderContents(response);     
    })
                 }
            
               }
               if(response.product_id=="8935336935650") 
               { 
                 if(!check_free_product2)
                 {
                        let payload = {
              items: [
                  // {
                  //     id: '46718036771042',
                  //     quantity: 1
                  // }
              ],
            sections: cart.getSectionsToRender().map((section) => section.id)
              };
                 fetch('/cart/add.js', {
                method: "POST", // Corrected typo in method
                headers: {
                    'Content-Type': 'application/json' // Corrected typo in headers
                },
                body: JSON.stringify(payload) // Corrected typo in JSON.stringify
            }).then((respose)=>{
                return respose.json()
              
            }).then((response)=>{
                cart.renderContents(response);     
            })
                 }
            
               }
            // free gallon atc
          //    fetch("/cart.js")
          // .then(resp => resp.json())
          // .then(result => {
          //   if (result.total_price >= 849900) {
          //     window.free_gallon(46471462256866, 1);
          //   } else {
          //     window.free_gallon(46471462256866, 0);
          //   }
          // })
          // .catch(error => {
          //   console.error('Error fetching cart:', error);
          // });

          //end of free gallon atc
            
             cartDrawer_newData().then((data) => {
                document.querySelector('#CartDrawer').innerHTML = data.querySelector('.shopify-section #CartDrawer').innerHTML;
                document.querySelector("cart-drawer")?.classList.remove("is-empty");
             });
            this.cartNotification.textContent = `You have added ${response.quantity} product view`;
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
             document.body.classList.remove('cstm-freebie-add');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.querySelector('.loading__spinner').previousElementSibling.removeAttribute('style');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
   const tgt_buy_it = document.querySelector('.shopify-payment-button__button.custom_buynow');
  tgt_buy_it.addEventListener('click',function()
                              {
                                document.querySelector('.cstm_submit_atc').click()
                                setTimeout(function()
                                           {
                                             window.location.href='/checkout'
                                           },3000)
                                 
                              })
}

async function cartDrawer_newData() {
  try {
    const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    const responseText = await response.text();
    return new DOMParser().parseFromString(responseText, 'text/html');
  } catch (error) {
    console.error('Error fetching cart data:', error);
    return '';
  }
}
// const GetcartDetails = async ()=>{
  //  const res = await  fetch("/cart.js")
  // const resData=  await res.json()
  // console.log("resData" , resData)
//   return resData
// }
